//Bootstrap JS
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bxslider-clean/src/js/jquery.bxslider'
import 'historyjs/scripts/bundled-uncompressed/html5/jquery.history'
import 'sharer.js'
const $ = require('jquery');
require('jquery-inview');

//glightbox
import GLightbox from 'glightbox';

import { setupRecaptcha } from "./recaptcha";

// swiper
//import Swiper from 'swiper/swiper-bundle.min.js';
import { setupFNTheme } from "./fn_theme";

setupRecaptcha();

GLightbox({
    selector: '.glightbox'
});

//let sliderSwiper = new Swiper(".swiper-slider", {
//    slidesPerView: "auto",
//    navigation: {
//        nextEl: ".carousel-control-next",
//        prevEl: ".carousel-control-prev",
//    },
//});

setupFNTheme();

let lgMaxWidth = window.matchMedia("(max-width: 991.9px)");

matchMediaHandler(lgMaxWidth, '[data-move][data-media-lg]');
lgMaxWidth.addEventListener("change", function (e) {
    matchMediaHandler(e, '[data-move][data-media-lg]');
});

let mdMaxWidth = window.matchMedia("(max-width: 767.9px)");

matchMediaHandler(mdMaxWidth, '[data-move][data-media-md]');
mdMaxWidth.addEventListener("change", function (e) {
    matchMediaHandler(e, '[data-move][data-media-md]');
});

let smMaxWidth = window.matchMedia("(max-width: 575.9px)");

matchMediaHandler(smMaxWidth, '[data-move][data-media-sm]');
smMaxWidth.addEventListener("change", function (e) {
    matchMediaHandler(e, '[data-move][data-media-sm]');
});

function matchMediaHandler(e, selector) {
    if (e.matches) {
        dataMove(selector);
    } else {
        dataMove(selector, true);
    }
}

// Function to activate tab based on hash after Bootstrap initialization
function activateTabFromHash() {
    const hash = window.location.hash;
    if (hash) {
        const tabLink = document.querySelector(`a[data-bs-toggle="pill"][href="${hash}"]`);
        if (tabLink) {
            new bootstrap.Tab(tabLink).show();
        }
    }
}

// Attach the function to the onload event and hash change event
window.onload = window.onhashchange = function () {
    // Delay activating the tab based on the hash tag in the URL
    setTimeout(activateTabFromHash, 0);
};

// Update the hash tag when a tab is shown
const tabElements = document.querySelectorAll('[data-bs-toggle="pill"]');
tabElements.forEach(tabElement => {
    tabElement.addEventListener('shown.bs.tab', event => {
        const tabTarget = event.target.getAttribute('href');
        if (tabTarget) {
            window.location.hash = tabTarget;
        }
    });
});

//swiper
//let carReviewSwiper = new Swiper(".carreview", {
//    loop: true,
//    spaceBetween: 30,
//    slidesPerView: 3,
//    freeMode: true,
//    watchSlidesProgress: true,
//    breakpoints: {
//        // mobile
//        0: {
//            spaceBetween: 10,
//        },
//        // small
//        576: {
//            spaceBetween: 10,
//        },
//        // medium
//        768: {
//            spaceBetween: 10,
//        },
//        // large
//        992: {
//            spaceBetween: 20,
//        },
//        // x-large
//        1200: {
//            spaceBetween: 25,
//        }
//    }
//});

//let mainSliderSwiper = new Swiper(".main-slider", {
//    loop: true,
//    spaceBetween: 30,
//    navigation: {
//        nextEl: ".swiper-button-next",
//        prevEl: ".swiper-button-prev",
//    },
//    thumbs: {
//        swiper: carReviewSwiper,
//    },


//});

//end swiper

//set focus on search input after click on search button (mobile)
let mobileSearchCollapse = document.getElementById('searchOffcanvasTop')
if (mobileSearchCollapse) {
    mobileSearchCollapse.addEventListener('shown.bs.offcanvas', function () {
        $(this).find('input[name="term"]')[0].focus();
    });
}


// Fix table responsiveness ***********************************************

// Select all tables in the document
let tables = document.getElementsByTagName('table');

// Loop through each table
for (let i = 0; i < tables.length; i++) {
    let table = tables[i];

    // Check if the parent of the table has the 'table-responsive' class
    if (!table.parentNode.classList.contains('table-responsive')) {
        // If it doesn't, create a new div with the class 'table-responsive'
        var wrapper = document.createElement('div');
        wrapper.className = 'table-responsive';

        // Insert the div before the table in the DOM
        table.parentNode.insertBefore(wrapper, table);

        // Move the table into the div
        wrapper.appendChild(table);
    }
}

// End fix table responsiveness *******************************************

function dataMove(selector, moveBack = false) {
    const elements = document.querySelectorAll(selector);

    elements.forEach(sourceElement => {
        const target = sourceElement.getAttribute('data-move');
        const targetElement = document.querySelector(target);

        if (targetElement) {
            if (moveBack) {
                moveChildElements(targetElement, sourceElement);
            } else {
                moveChildElements(sourceElement, targetElement);
            }
        }
    });
}

function moveChildElements(sourceElement, destinationElement) {
    while (sourceElement.firstChild) {
        destinationElement.appendChild(sourceElement.firstChild);
    }
}

// Example starter JavaScript for disabling form submissions if there are invalid fields
(function () {
    'use strict'

    $('section[id^="group-section-"]').on('inview', function (event, isInView) {
        if (isInView) {
            // Get the id of the section
            var sectionName = $(this).attr('id');
            console.log("section name: " + sectionName);
            // Push an event to the dataLayer with the section name
            dataLayer.push({
                'event': 'virtualPageView',
                'virtualPageURL': window.location.pathname + '#' + sectionName,
                'virtualPageTitle': sectionName // or any other title you want to give
            });
        }
    });

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.querySelectorAll('.needs-validation')

    // Loop over them and prevent submission
    Array.prototype.slice.call(forms)
        .forEach(function (form) {
            form.addEventListener('submit', function (event) {
                if (!form.checkValidity()) {
                    event.preventDefault()
                    event.stopPropagation()
                }

                form.classList.add('was-validated')
            }, false)
        })
})()
